import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { HotelListComponent } from './pages/hotel-list/hotel-list.component';
import { HotelDetailComponent } from './pages/hotel-detail/hotel-detail.component';
import { BlogListComponent } from './pages/blog-list/blog-list.component';
import { BlogDetailComponent } from './pages/blog-detail/blog-detail.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { AboutComponent } from './pages/about/about.component';
import { HelpCenterComponent } from './pages/help-center/help-center.component';
import { LoginComponent } from './pages/login/login.component';
import { RegisterComponent } from './pages/register/register.component';
import { InvoiceComponent } from './pages/invoice/invoice.component';
import { ContactComponent } from './pages/contact/contact.component';
import { BookingConfirmationComponent } from './pages/booking-confirmation/booking-confirmation.component';
import { PassengerInfoComponent } from './pages/passenger-info/passenger-info.component';
import { PaymentComponent } from './pages/payment/payment.component';
import { PaymentCallbackComponent } from './pages/payment-callback/payment-callback.component';
import { PaymentSuccessComponent } from './pages/payment-success/payment-success.component';
import { PaymentFailedComponent } from './pages/payment-failed/payment-failed.component';
import { GizlilikPolitikasiComponent } from './pages/gizlilik-politikasi/gizlilik-politikasi.component';
import { KullanimKosullariComponent } from './pages/kullanim-kosullari/kullanim-kosullari.component';
import { MesafeliSatisSozlesmesiComponent } from './pages/mesafeli-satis-sozlesmesi/mesafeli-satis-sozlesmesi.component';
import { IptalIadePolitikasiComponent } from './pages/iptal-iade-politikasi/iptal-iade-politikasi.component';
import { AccountComponent } from './pages/account/account.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { MinimalLayoutComponent } from './layouts/minimal-layout/minimal-layout.component';
import { HomeLayoutComponent } from './layouts/home-layout/home-layout.component';
import { bookingGuard, passengerInfoGuard } from './core/guards';

export const routes: Routes = [
  // Payment callback sayfaları (En üstte, wildcard'dan önce!)
  {
    path: 'payment',
    component: MinimalLayoutComponent,
    children: [
      { path: 'success', component: PaymentSuccessComponent },
      { path: 'failed', component: PaymentFailedComponent },
    ]
  },
  
  // Home sayfası için özel layout (özel footer içerir)
  {
    path: '',
    component: HomeLayoutComponent,
    children: [
      { path: '', component: HomeComponent }
    ]
  },
  
  // Diğer sayfalar için ana layout (shared footer içerir)
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      { path: 'hotel-list', component: HotelListComponent },
      { path: 'hesabim', component: AccountComponent },
      { path: 'hotel-detail/:productKey', component: HotelDetailComponent },
      { 
        path: 'blog', 
        component: BlogListComponent
      },
      { path: 'blog/:slug', component: BlogDetailComponent },
      { path: 'about', component: AboutComponent },
      { path: 'contact', component: ContactComponent },
      { path: 'help-center', component: HelpCenterComponent },
      { 
        path: 'yolcu-bilgileri', 
        component: PassengerInfoComponent,
        canActivate: [bookingGuard]  // Aktif rezervasyon gerekli
      },
      { 
        path: 'odeme', 
        component: PaymentComponent,
        canActivate: [bookingGuard, passengerInfoGuard]  // Rezervasyon + yolcu bilgisi gerekli
      },
      { 
        path: 'rezervasyon-onay', 
        component: BookingConfirmationComponent,
        canActivate: [bookingGuard]  // Aktif rezervasyon gerekli
      },
      
      // Yasal Sayfalar
      { path: 'gizlilik-politikasi', component: GizlilikPolitikasiComponent },
      { path: 'kullanim-kosullari', component: KullanimKosullariComponent },
      { path: 'mesafeli-satis-sozlesmesi', component: MesafeliSatisSozlesmesiComponent },
      { path: 'iptal-iade-politikasi', component: IptalIadePolitikasiComponent },
    ]
  },
  
  // Footer olmayan sayfalar için minimal layout
  {
    path: '',
    component: MinimalLayoutComponent,
    children: [
      { path: 'login', component: LoginComponent },
      { path: 'register', component: RegisterComponent },
      { path: 'invoice', component: InvoiceComponent },
      { path: 'payment-callback', component: PaymentCallbackComponent },
    ]
  },

  // 404 sayfası
  {
    path: '404',
    component: MainLayoutComponent,
    children: [
      { path: '', component: NotFoundComponent }
    ]
  },
  
  // Bilinmeyen route'ları ana sayfaya yönlendir
  { path: '**', redirectTo: '' }
];
